import { render, staticRenderFns } from "./ChangeStudentData.vue?vue&type=template&id=43d18e58&scoped=true&"
import script from "./ChangeStudentData.vue?vue&type=script&lang=js&"
export * from "./ChangeStudentData.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStudentData.vue?vue&type=style&index=0&id=43d18e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d18e58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43d18e58')) {
      api.createRecord('43d18e58', component.options)
    } else {
      api.reload('43d18e58', component.options)
    }
    module.hot.accept("./ChangeStudentData.vue?vue&type=template&id=43d18e58&scoped=true&", function () {
      api.rerender('43d18e58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/ChangeStudentData/ChangeStudentData.vue"
export default component.exports